export default __webpack_public_path__ + "static/media/programming.a58903ac.jpg";